import { apiService } from './apiService';
import { SupplementCatalog } from '../models/diary';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.eternal-health.com/api';

export interface SupplementCatalogPaginatedResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: SupplementCatalog[];
  totalPages: number;
  actualPage: number;
}

export interface CreateSupplementData {
  name: string;
  purchaseUrl?: string;
  description?: string;
}

export const supplementCatalogService = {
  getAll: async (page: number = 1, perpage: number = 10, search: string = ''): Promise<SupplementCatalogPaginatedResponse> => {
    const params = new URLSearchParams({ page: String(page), perpage: String(perpage) });
    if (search.trim()) params.set('search', search.trim());
    const url = `${API_BASE_URL}/clinic/supplement-catalog/?${params.toString()}`;
    try {
      const response = await apiService.get(url);
      return {
        ...response,
        actualPage: page,
        totalPages: Math.ceil(response.count / perpage) || 1,
      };
    } catch (error) {
      console.error('Error fetching supplement catalog:', error);
      throw error;
    }
  },

  getOne: async (id: number): Promise<SupplementCatalog> => {
    const url = `${API_BASE_URL}/clinic/supplement-catalog/${id}/`;
    try {
      const response = await apiService.get(url);
      return response;
    } catch (error) {
      console.error(`Error fetching supplement ${id}:`, error);
      throw error;
    }
  },

  create: async (data: CreateSupplementData): Promise<SupplementCatalog> => {
    const url = `${API_BASE_URL}/clinic/supplement-catalog/`;
    try {
      const response = await apiService.post(url, data);
      return response;
    } catch (error) {
      console.error('Error creating supplement:', error);
      throw error;
    }
  },

  update: async (id: number, data: Partial<CreateSupplementData>): Promise<SupplementCatalog> => {
    const url = `${API_BASE_URL}/clinic/supplement-catalog/${id}/`;
    try {
      const response = await apiService.patch(url, data);
      return response;
    } catch (error) {
      console.error(`Error updating supplement ${id}:`, error);
      throw error;
    }
  },

  remove: async (id: number): Promise<void> => {
    const url = `${API_BASE_URL}/clinic/supplement-catalog/${id}/`;
    try {
      await apiService.delete(url);
    } catch (error) {
      console.error(`Error deleting supplement ${id}:`, error);
      throw error;
    }
  },
};
